// src/components/Header.js
import React, {useEffect, useRef, useState} from 'react';

// 靜態資源
import homeIcon from '../assets/img/icon_home.svg';

const Header = (prop) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const headerRef = useRef(null);

    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            const offset = 20;
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({top: y, behavior: 'smooth'});
            window.history.pushState(null, null, `#${targetId}`);
        } else {
            window.location.href = `/#${targetId}`;
        }
        setMenuOpen(false);
    };

    // 點擊頁面其他區域自動關閉選單
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (headerRef.current && !headerRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <header ref={headerRef}>
            <div className="wrap">
                <div className="logo_side">
                    <a href="/" className="logo navLinkIndex">
                        {prop?.data?.logoBig ? (
                            <img src={prop.data.logoBig} alt="Date Logo" width="135" height="45"/>
                        ) : ''}
                    </a>
                    <div
                        id="menu-toggle"
                        className={`menu-icon ${menuOpen ? 'active' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        role="button"
                        tabIndex="0"
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                setMenuOpen(!menuOpen);
                            }
                        }}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <nav id="sidr" className={menuOpen ? 'sidr' : ''}>
                    <a
                        href="#topic_about"
                        className="navLinkIndex"
                        data-target="topic_about"
                        onClick={(e) => handleNavClick(e, 'topic_about')}
                    >
                        ABOUT DATE
                    </a>
                    <a
                        href="#topic_speaker"
                        className="navLinkIndex"
                        data-target="topic_speaker"
                        onClick={(e) => handleNavClick(e, 'topic_speaker')}
                    >
                        講師陣容
                    </a>
                    <a
                        href="#topic_aganda"
                        className="navLinkIndex"
                        data-target="topic_aganda"
                        onClick={(e) => handleNavClick(e, 'topic_aganda')}
                    >
                        精彩議程
                    </a>
                    <a
                        href="#topic_report"
                        className="navLinkIndex"
                        data-target="topic_report"
                        onClick={(e) => handleNavClick(e, 'topic_report')}
                    >
                        專題報導
                    </a>
                    <a
                        href={prop?.data?.ticketLink || '#'}
                        className="btn_start">
                        立即索票
                    </a>
                    <a href="https://info.taiwantrade.com/" target="_blank" rel="noreferrer">
                        <img src={homeIcon} alt="Home Icon"/>
                    </a>
                </nav>
            </div>
        </header>
    );
};

export default Header;
